import templateUrl from './support-contact-info.component.html'

export const SupportContactInfoComponent = {
    templateUrl,
    controller: class {
        constructor() {
            this.supportEmail = "apexsupport@herbjoyent.com";
            this.supportPhone = "1-877-822-6505";
            // Remove non-digital characters from data displayed in tel field.
            this.supportPhoneTel = this.supportPhone.replace(/[^\d]/g, "");
            this.hoursOfOperation = "8:30 am - 5:00 pm EST"
        }
    }
}
